import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`font-heading font-bold text-lg whitespace-nowrap cursor-pointer transition-colors duration-300 ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
          >
            VigorBuy Hub
          </Link>

          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
              }`}
            >
              Home
            </Link>
            <Link
              to="/article/vigorbuy-spreadsheet-complete-guide"
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
              }`}
            >
              Shopping Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
              }`}
            >
              Vigorbuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-accent-500 hover:bg-accent-600 text-white text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors duration-200 ${
              scrolled ? 'text-foreground-800 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} w-5 h-5 flex items-center justify-center`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white rounded-xl border border-background-200 shadow-lg mt-2 p-4 mb-4 max-h-[70vh] overflow-y-auto">
            <div className="flex flex-col gap-1">
              <Link to="/" onClick={() => setMobileOpen(false)} className="flex items-center gap-2.5 px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-50 rounded-lg cursor-pointer transition-colors">
                <i className="ri-home-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
                Home
              </Link>
              <Link to="/article/vigorbuy-spreadsheet-complete-guide" onClick={() => setMobileOpen(false)} className="flex items-center gap-2.5 px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-50 rounded-lg cursor-pointer transition-colors">
                <i className="ri-book-open-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
                Shopping Guide
              </Link>
              <Link to="/article/vigorbuy-spreadsheet-safety-guide" onClick={() => setMobileOpen(false)} className="flex items-center gap-2.5 px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-50 rounded-lg cursor-pointer transition-colors">
                <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
                Safety Guide
              </Link>
              <div className="border-t border-background-100 my-2"></div>
              <p className="px-3 py-1 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Product Categories</p>
              {[
                { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
                { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
                { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
                { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-star-line' },
                { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
                { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-shopping-bag-3-line' },
                { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
                { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-contrast-drop-line' },
              ].map((cat) => (
                <a key={cat.name} href={cat.url} target="_blank" rel="noopener nofollow" onClick={() => setMobileOpen(false)} className="flex items-center gap-2.5 px-3 py-2 text-sm text-foreground-600 hover:bg-background-50 rounded-lg cursor-pointer transition-colors">
                  <i className={`${cat.icon} w-4 h-4 flex items-center justify-center text-foreground-400`}></i>
                  {cat.name}
                </a>
              ))}
              <div className="border-t border-background-100 my-2"></div>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 mt-1 bg-accent-500 hover:bg-accent-600 text-white text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer">Buy It Now</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}